module.exports = __webpack_public_path__ + "img/step3img.13b0a49d.png";